export default __webpack_public_path__ + "assets/images/5bc54f8535cd4a032738da06967ba688.svg";